<!--
 * @Author: lan.h
 * @Date: 2022-02-22 16:23:02
 * @LastEditors:  
 * @LastEditTime: 2023-02-20 15:56:23
 * @Description: 文章、视频详情
-->
<template>
  <div class="main-index">
    <div class="main">
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div class="main_lt">
        <h1>{{detail.title}}</h1>

        <div class="summary">
          <div class="lt">
            <span>作者：</span>
            <span>{{detail.displayUser}}</span>
            <span>{{detail.publishTime | time_moment('YYYY-MM-DD HH:mm')}}</span>
          </div>
          <div class="rt">
            <Button class="collect on" v-if="detail.favorite" @click="cancelCollect('4', detail.id, delCollectCb)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(作者收藏/取消收藏)', '点击量'])">
              <i class="iconfont">&#xe66f;</i>已收藏
            </Button>
            <Button class="collect" v-else @click="addCollect('4', detail.id, addCollectCb)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(作者收藏/取消收藏)', '点击量'])">
              <i class="iconfont">&#xe66f;</i>添加收藏
            </Button>
            <Button class="share" @click="isModal = true">
              <i class="iconfont">&#xe641;</i>微信分享
            </Button>
          </div>
        </div>
        <!-- 公司、投资机构 -->
        <div class="article-entity" v-if="detail.entityEventInfo" @click="toEntity(detail.entityEventInfo)">
          <div class="entity">
            <div class="c_name">
              <span>{{detail.entityEventInfo.shortName}}</span>
              <div class="mainpage" @click.stop="toMainPage(detail.entityEventInfo.mainPage)" v-if="detail.entityEventInfo.mainPage">{{detail.entityEventInfo.mainPage}}</div>
            </div>
            <div class="comp-src-name"><i class="iconfont">&#xe6a7;</i>企业数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click.stop="haddleApplyTry2(32)"> 提供支持</div>
          </div>
          <div class="wap">
            <div class="desc" v-if="detail.entityEventInfo.description || detail.entityEventInfo.roundId || detail.entityEventInfo.stateId">
              {{detail.entityEventInfo.description ? detail.entityEventInfo.description : ''}}
              <i v-if="detail.entityEventInfo.description && detail.entityEventInfo.roundId">|</i>
              {{detail.entityEventInfo.roundId | deal('round', 'name', '')}}
              <i v-if="(detail.entityEventInfo.description || detail.entityEventInfo.roundId) && detail.entityEventInfo.stateId">|</i>
              {{detail.entityEventInfo.stateId | deal('state', 'state', '')}}
            </div>
            <div class="entity-content">
              <div v-if="detail.entityEventInfo.addressId"><i class="iconfont">&#xe63a;</i>{{detail.entityEventInfo.addressId | addressDeal(2)}}</div>
              <div v-if="detail.entityEventInfo.eventTime"><i class="iconfont">&#xe632;</i>{{detail.entityEventInfo.eventTime | time_moment}}</div>
              <div v-if="detail.entityEventInfo.amount"><i class="iconfont">&#xe621;</i>融资金额：{{detail.entityEventInfo.amount | | amountPrecise(detail.entityEventInfo.unitId, detail.entityEventInfo.precise)}}</div>
              <div v-if="detail.entityEventInfo.investorInfo && detail.entityEventInfo.investorInfo.length > 0"><i class="iconfont">&#xe6ba;</i>{{detail.entityEventInfo.investorInfo[0].name}}</div>
            </div>
          </div>
          <div class="kan">查看</div>
        </div>
        <!-- 医疗机构 -->
        <div class="article-entity hospital" v-if="detail.hospitalInfo" @click="toEntity(detail.hospitalInfo)">
          <div class="entity">
            <div class="c_name">
              <span>{{detail.hospitalInfo.shortName}}</span>
              <div class="tag" v-if="detail.hospitalInfo.hospitalLevel1">{{detail.hospitalInfo.hospitalLevel1 | deal('hlht_level1')}}</div>
              <div class="tag" v-if="detail.hospitalInfo.hospitalLevel2">{{detail.hospitalInfo.hospitalLevel2 | deal('hlht_level2')}}</div>
            </div>
            <div class="comp-src-name"><i class="iconfont">&#xe6a7;</i>医疗机构数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click.stop="haddleApplyTry2(32)"> 提供支持</div>
          </div>
          <div class="entity-content wap">
            <div v-if="detail.hospitalInfo.typeId">机构类型：{{detail.hospitalInfo.typeId | deal('hospital_type')}}</div>
            <div v-if="detail.hospitalInfo.czType">机构性质：{{detail.hospitalInfo.czType | deal('hos_cz_type')}}</div>
            <div v-if="detail.hospitalInfo.addressId">所在地址：{{detail.hospitalInfo.addressId | addressDeal(2)}}</div>
            <div v-if="detail.hospitalInfo.mainPage" @click.stop="toMainPage(detail.hospitalInfo.mainPage)">官网地址：<a>{{detail.hospitalInfo.mainPage}}</a></div>
          </div>
          <div class="kan">查看</div>
        </div>
        <!-- 内容 -->
        <div class="content" v-if="detail.type == 0" v-html="detail.content"></div>
        <div class="content" v-if="detail.type == 1">
          <video :controls="true" class="video-js vjs-big-play-centered vjs-fluid" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-playsinline style="width: 100%;" autoplay="autoplay" ref="video" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '视频文章(播放/暂停)', '点击量'])" id="myVideo1">
            <source :src="$store.state.img_req_url + detail.filePath" type="video/mp4">
            </source>
          </video>
        </div>
        <div class="bot_cnt">
          <div class="tags1" v-if="detail.appLayerTagRespList.length > 0">
            <span>相关赛道</span>
            <a v-for="tag in detail.appLayerTagRespList" :key="tag" @click="toTrack(tag.id)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(赛道标签)', '点击量'])">{{tag.appLayerTagName}}</a>
          </div>
          <div class="tags2" v-if="detail.mediaTagRespList.length > 0">
            <span>文章标签</span>
            <a v-for="tag in detail.mediaTagRespList" :key="tag" @click="toArticelList(tag)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(文章标签)', '点击量'])">{{tag.tagName}}</a>
          </div>
          <div class="tags3">
            <div>如果您想对接动脉网所报道的企业，请<a href="https://www.vbdata.cn/Form/compContact" target="_blank">填写表单</a>，我们的工作人员将尽快为您服务。</div>
            <div>注：文中如果涉及企业数据，均由受访者向分析师提供并确认。</div>
            <div>声明：动脉网所刊载内容之知识产权为动脉网及相关权利人专属所有或持有。转载请联系tg@vcbeat.net。</div>
          </div>
        </div>
        <!-- 作者简介 -->
        <div class="author-desc">
          <img class="logo" :src="author.logo | logo_show('', $store.state.static_img_url+'pic/default_header.png')">
          <div class="center">
            <p class="name">{{author.displayUser}}<img :src="$store.state.static_img_url+'pic/vcbeat/r.png'"></p>
            <p class="desc">{{author.userDescription}}</p>
          </div>
          <div class="right">
            分享
            <div class="weixin" @click="isModal = true" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(作者分享)', '点击量'])">
              <i class="iconfont">&#xe641;</i>
            </div>
            <div class="follow on" v-if="detail.favorite" @click="cancelCollect('4', detail.id, delCollectCb)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(作者收藏/取消收藏)', '点击量'])">
              <i class="iconfont">&#xe66f;</i>
            </div>
            <div class="follow" v-else @click="addCollect('4', detail.id, addCollectCb)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(作者收藏/取消收藏)', '点击量'])">
              <i class="iconfont">&#xe66e;</i>
            </div>
          </div>
        </div>
        <!-- 动脉橙推荐 -->
        <div class="member">
          <div class="left">
            <div>
              <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙">
              <div class="button" @click="deModel">注册试用</div>
            </div>
          </div>
          <div class="right">
            <div class="line-1">以上数据来自<span class="orange" @click="haddleApplyTry2(23)">动脉橙产业智库</span>。</div>
            <div class="line-2">
              <p>我们以独创的在线数据库方式，为健康产业人士提供全方位和实时的市场资讯、行业数据和分析师见解。现已覆盖数字健康、医疗器械、生物医药等近500+细分赛道，涉及公司名单、招投标、投融资信息、头部企业动态等各类数据并持续更新。</p>
            </div>
            <div class="line-3">
              点击 <span class="blue" @click="haddleApplyTry2(24)">【申请试用】</span>了解动脉橙产业智库更多内容。
            </div>
          </div>
        </div>
        <!-- 精彩内容推荐 -->
        <div class="rc-content" v-if="re_list.length > 0">
          <div class="title">精彩内容推荐</div>
          <div class="a-list">
            <div class="item" v-for="item, index in re_list" :key="index" @click="toArticle(item.articleId)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '左侧(推荐内容)', '点击量'])">
              <div class="img"><img :src="item.coverImagePath | logo_show"></div>
              <p class="over-p2">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
      <RightModel class="main_rt">
        <!-- 作者简介 -->
        <div class="author">
          <div class="author-header">
            <img class="logo" :src="author.logo | logo_show('', $store.state.static_img_url+'pic/default_header.png')">
            <div class="right">
              <p class="name">{{author.displayUser}}<img :src="$store.state.static_img_url+'pic/vcbeat/r.png'"></p>
              <p class="desc">共发表文章{{author.total}}篇</p>
            </div>
          </div>
          <div class="lately" v-if="author.recentlyArticleIndex.length > 0">
            <div class="se-title">最近内容</div>
            <ul>
              <li v-for="item, index in author.recentlyArticleIndex" :key="index">
                <div class="over-p2" @click="toArticle(item.articleId)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(作者_文章)', '点击量'])">{{item.articleTitle}}</div>
                <p>{{item.publishTime | time_standard}}</p>
              </li>
            </ul>
            <div class="flash-more">
              <a @click="toAuthor()" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(作者_文章更多)', '点击量'])">查看 {{author.displayUser}} 的全部文章</a>
            </div>
          </div>
        </div>
        <!-- 文中包含的企业和机构 -->
        <div class="org" v-if="detail.entityInfoList.length > 0">
          <div class="mode-title">
            <span class="title-p">文中包含的企业和机构</span>
          </div>
          <div class="org-item" v-for="item, index in detail.entityInfoList" :key="index">
            <div class="logo"><img :src="item.logo | logo_show"></div>
            <div class="content">
              <div class="over-p1" @click="toEntity(item)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(文章包括的公司机构)', '点击量'])">{{item.shortName }}</div>
              <p class="over-p1">{{item.entityDes}}</p>
            </div>
            <div v-if="!item.subscribe" class="follow1" @click="haddleSubscribe(item, index)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(文章包括的公司机构_关注/取消)'])">关注</div>
            <div v-else class="follow2" @click="haddleCancel(item, index)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(文章包括的公司机构_关注/取消)'])">已关注</div>
          </div>
        </div>
        <!-- 最新融资 -->
        <LatestFinancing pageType="2"></LatestFinancing>
        <!-- 推荐赛道 -->
        <RCtrack pageType="2"></RCtrack>
        <!-- 优质报告 -->
        <RCreport pageType="2"></RCreport>
        <!-- 报告图表 -->
        <ReportChart pageType="2"></ReportChart>
        <!-- 上下篇 -->
        <div class="relation" v-if="index_list.beforeIndex">
          <div class="mode-title">
            <span class="title-p">上一篇</span>
          </div>
          <p class="title" @click="toArticle(index_list.beforeIndex.articleId)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(文章上下篇)'])">{{index_list.beforeIndex.articleTitle}}</p>
          <div class="time">{{index_list.beforeIndex.publishTime | time_standard}}</div>
        </div>
        <div class="relation" v-if="index_list.afterIndex">
          <div class="mode-title">
            <span class="title-p">下一篇</span>
          </div>
          <p class="title" @click="toArticle(index_list.afterIndex.articleId)" onclick="_czc.push(['_trackEvent', '文章详细页(新)', '右侧(文章上下篇)'])">{{index_list.afterIndex.articleTitle}}</p>
          <div class="time">{{index_list.afterIndex.publishTime | time_standard}}</div>
        </div>
      </RightModel>
    </div>
    <Modal v-model="isModal" :footer-hide="true" :width="320" class="share-mode" @on-cancel="cancel">
      <div class="share">分享</div>
      <div class="share_img"></div>
      <div class="share_desc">微信扫描二维码分享文章</div>
    </Modal>
  </div>
</template>

<script>
import LatestFinancing from '@/components/vcbeat/LatestFinancing'
import RCtrack from '@/components/vcbeat/RCtrack'
import RCreport from '@/components/vcbeat/RCreport'
import ReportChart from '@/components/vcbeat/ReportChart'
import RightModel from '@/components/RightModel'
import {
  articleContent,
  authorRelation,
  authorIndex,
  articleRelation,
  addPuv,
  wxShare,
} from '../../service'
import { collect_mixin } from 'js/collect_mixin'
import { atten_common } from 'js/atten_common'
import { share } from 'mobile/js/wx_share'
export default {
  metaInfo() {
    return {
      title: this.meta_title,
      meta: [
        { property: 'og:title', content: this.detail.title + '-动脉网' },
        { property: 'og:description', content: this.detail.summary },
        { property: 'og:url', content: this.$store.state.index2_path + this.$route.fullPath },
        { property: 'og:image', content: this.$store.state.img_req_url + this.detail.logoPath },
      ],
    }
  },
  mixins: [collect_mixin, atten_common],
  inject: ['haddleApplyTry2', 'login'],
  data() {
    return {
      loading: false,
      detail: {
        title: '',
        mediaTagRespList: [],
        appLayerTagRespList: [],
        entityInfoList: [],
        entityEventInfo: {},
      },
      isModal: false,
      author: {
        recentlyArticleIndex: [],
      },
      index_list: {},
      re_list: [],
      meta_title: '动脉网-全球产业链接平台'
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
  },
  created() {
    this.articleContent()
    this.authorRelation()
    this.authorIndex()
    this.articleRelation()
  },
  methods: {
    /**
     * @description: 文章标签跳转
     * @param {*} item
     * @return {*}
     */
    toArticelList(item) {
      const href = this.$store.state.index2_path + '/articleList?tag=' + item.id
      window.open(href, '_blank')
    },
    toAuthor() {
      const href =
        this.$store.state.index2_path + '/Article/authorArticle/keyword/' + this.author.base64Id
      window.open(href, '_blank')
    },
    addCollectCb() {
      this.detail.favorite = true
      this.detail = { ...this.detail }
    },
    delCollectCb() {
      this.detail.favorite = false
      this.detail = { ...this.detail }
    },
    haddleSubscribe(item, index) {
      if (this.user_key) {
        const cb = () => {
          this.detail.entityInfoList[index].subscribe = true
          this.subscribeSuccess()
        }
        this.addSubscribe(item.entityType, item.entityId, cb)
      } else {
        this.login()
      }
    },
    haddleCancel(item, index) {
      if (this.user_key) {
        let i = this.$store.state.attention.subscribe.findIndex(
          (a) => a.sub_type_id == item.entityId
        )
        if (i > -1) {
          const cb = () => {
            this.detail.entityInfoList[index].subscribe = false
            this.cancelSuccess()
          }
          this.deleteSubscribe(this.$store.state.attention.subscribe[i]['id'], cb)
        }
      } else {
        this.login()
      }
    },
    toMainPage(mainPage) {
      const href = mainPage
      window.open(href, '_blank')
    },
    toEntity(a) {
      if (a.entityType == 0) {
        const href = this.$store.state.index_path + '/companyDetail/' + a.uid
        window.open(href, '_blank')
      } else if (a.entityType == 1) {
        const href = this.$store.state.index_path + '/orgDetail/' + a.uid
        window.open(href, '_blank')
      } else if (a.entityType == 3) {
        const href = this.$store.state.index_path + '/hospitalDetail/' + a.uid
        window.open(href, '_blank')
      }
    },
    deModel() {
      this.haddleApplyTry2(15)
    },
    toArticle(a) {
      const href = this.$store.state.index2_path + '/' + a
      window.open(href, '_blank')
    },
    haddleShare() {
      let share_link = this.$store.state.index2_path + '/' + this.detail.id
      jQuery($('.share_img')).qrcode({
        width: 120,
        height: 120,
        correctLevel: 0,
        text: share_link,
      })
    },
    cancel() {
      this.isModal = false
    },
    /**
     * @description: 文章详情
     * @param {*}
     * @return {*}
     */
    async articleContent() {
      this.loading = true
      let res = await articleContent(
        {
          id: this.$route.params.id,
          page: 1,
          size: 50,
          userKey: this.$store.state.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 'detail', res.data)
        this.meta_title = this.detail.title + '-动脉网'

        this.loading = false
        this.haddleShare()
        this.getAddPuv()
        this.wxShare()
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 作者相关信息及最近文章
     * @param {*}
     * @return {*}
     */
    async authorRelation() {
      let res = await authorRelation(
        {
          articleId: this.$route.params.id,
          page: 1,
          size: 3,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 'author', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 上下篇
     * @param {*}
     * @return {*}
     */
    async authorIndex() {
      let res = await authorIndex(
        {
          id: this.$route.params.id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 'index_list', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * @description: 精彩内容推荐
     * @param {*}
     * @return {*}
     */
    async articleRelation() {
      let res = await articleRelation(
        {
          articleId: this.$route.params.id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 're_list', res.data.slice(0, 4))
      } else {
        this.$Message.error(res.msg)
      }
    },
    toTrack(tag) {
      const href = this.$store.state.index_path + '/trackDetail?tag=' + tag
      window.open(href, '_blank')
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.$store.state.user_key,
        url: window.location.href,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    async wxShare() {
      let res = await wxShare(
        { url: this.$store.state.index2_path + this.$route.fullPath },
        (error) => {
          this.$Message.error('请求错误!')
        }
      )
      share(
        res,
        {
          title: '动脉网 | ' + this.detail.title,
          desc: this.detail.summary,
          link: this.$store.state.index2_path + this.$route.fullPath,
          imgUrl: this.$store.state.img_req_url + this.detail.logoPath,
        },
        this,
        window.location.href
      )
      console.log(this.$store.state.img_req_url + this.detail.logoPath)
    },
  },
  components: {
    LatestFinancing,
    RCtrack,
    RCreport,
    ReportChart,
    RightModel,
  },
}
</script> 

<style lang="stylus" scoped>
@import '~styles/common_vcbeat.stylus'
.main-index
  background #fff
.main
  width 1200px
  margin 0 auto
  padding 36px 0
  display flex
  &_lt
    flex 0 0 820px
    h1
      font-size 30px
      font-weight 500
      color #333333
      line-height 42px
    .summary
      font-size 14px
      font-weight 500
      color #999
      margin-top 22px
      padding-bottom 22px
      position relative
      line-height 1
      display flex
      justify-content space-between
      align-items center
      &::after
        position absolute
        bottom 0
        left 0
        content ''
        width 80px
        height 1px
        background #DDDDDD
      .lt
        span:nth-child(1)
          color #333
        span:nth-child(2)
          padding-right 40px
          position relative
          &:after
            position absolute
            right 20px
            top 3px
            content ''
            width 1px
            height 14px
            background-color #999
      .rt
        .collect, .share
          height 32px
          background #FF8824
          border-radius 6px
          font-size 14px
          color #fff
          border-color #ff8824
          line-height 1
          box-shadow none
          >>> span
            display flex
            align-items center
            justify-content center
            .iconfont
              font-size 14px
              margin-right 8px
          &:hover
            background #f60
            border-color #f60
          &.on
            color #666666
            border-color #F5F5F5
            background #F5F5F5
            >>> span
              .iconfont
                color #FF8824
            &:hover
              background #f0f0f0
              border-color #f0f0f0
        .share
          color #2EC66B
          border-color #2EC66B
          background none
          margin-left 10px
          >>> span
            .iconfont
              font-size 16px
          &:hover
            background #2EC66B
            border-color #2EC66B
            color #fff
    .article-entity
      background #FFF9F3
      padding 14px 20px
      margin-top 20px
      width 100%
      cursor pointer
      position relative
      .entity
        display flex
        justify-content space-between
        align-items flex-start
        .c_name
          font-size 20px
          font-weight 600
          color #333333
          line-height 1
          display flex
          align-items flex-end
          flex 1
          span
            position relative
            line-height 1
            &:hover
              color #FF8824
              transition all 0.5s
          .mainpage
            font-size 14px
            color #ff8824
            margin-left 10px
            transition all 0.3s
            &:hover
              color #ffb87c
      .wap
        width calc(100% - 80px)
      .desc
        font-size 12px
        font-weight 500
        color #666666
        line-height 16px
        margin-top 11px
        i
          font-size 12px
          font-style normal
          margin 0 10px
          color #eee
      .entity-content
        display flex
        flex-wrap wrap
        line-height 1
        >div
          margin-right 30px
          font-size 12px
          margin-top 15px
          line-height: 16px;
          i
            margin-right 5px
            font-size 12px
        >div:last-child
          margin-right 0
      .comp-src-name
        margin-top 5px
      .kan
        font-size 12px
        line-height 1
        color #FF8824
        position absolute
        right 30px
        bottom 16px
        &::after
          border solid #FF8824
          border-width 0 1px 1px 0
          display inline-block
          padding 3px
          transform rotate(-45deg)
          position absolute
          top 3px
          right -10px
          content ''
    .hospital
      .c_name
        align-items: center
        .tag
          background: #FF8824;
          line-height 20px
          border-radius: 4px
          padding 0 6px
          font-size: 12px;
          color: #FEFEFE;
          margin-left 8px
      .entity-content
        margin-top 20px
    .content
      margin-top 18px
      font-size 16px
      line-height 30px
      >>>img
        max-width 100%
        max-height 100%
      >>>table
        width: 100%
        td
          border 1px solid #eee
    .bot_cnt
      width 100%
      margin-top 30px
      .tags1, .tags2
        span
          font-size 12px
          font-weight 500
          color #999999
          line-height 18px
      .tags1
        a
          background #FFF8F1
          border-radius 13px
          font-size 12px
          font-weight 400
          color #FF8824
          line-height 1
          padding 6px 8px
          display inline-block
          margin-left 10px
          transition all 0.5s
          &:first-child
            margin-left 15px
          &:hover
            background #FF8824
            color #fff
      .tags2
        margin-top 30px
        a
          font-size 12px
          font-weight 400
          color #FF8824
          display inline-block
          margin-left 10px
          line-height 1
          transition all 0.5s
          &:first-child
            margin-left 15px
          &:hover
            color #FF6600
      .tags3
        font-size 14px
        color #666
        margin-top 20px
        div
          &:nth-child(1)
            font-weight bold
            margin-bottom 10px
            a
              color #FF8824
              cursor pointer
          &:nth-child(2)
            margin-bottom 14px
    .author-desc
      width 100%
      height 70px
      margin-top 30px
      background rgba(#FFF4EA, 0.95)
      border-top 2px solid rgba(#FF8824, 0.8)
      padding 10px 20px
      display flex
      align-items center
      justify-content space-between
      .logo
        width 48px
        height 48px
        border-radius 50%
        margin-right 12px
      .center
        flex 1
        .name
          font-size 18px
          font-weight 500
          color #333333
          line-height 1
          display flex
          align-items center
          img
            margin-left 5px
        .desc
          font-size 13px
          font-weight 500
          color #999999
          line-height 1
          margin-top 10px
      .right
        display flex
        align-items center
        font-size 12px
        font-weight 500
        color #999999
        width 105px
        >div
          margin-left 10px
        .weixin
          width 30px
          height 30px
          background #FFFFFF
          border 1px solid #2EC66B
          border-radius 50%
          cursor pointer
          text-align center
          line-height 30px
          i
            color #2EC66B
            font-size 15px
        .follow
          width 30px
          height 30px
          background #FFFFFF
          border 1px solid #EEEEEE
          border-radius 50%
          cursor pointer
          display flex
          justify-content center
          align-items center
          i
            color #ccc
            font-size 14px
            line-height 1
          &.on
            background #ff8824
            border-color #ff8824
            i
              color #fff
    .member
      margin-top 30px
      display flex
      justify-content space-between
      .left
        width 216px
        height 205px
        background #FFFBF7
        display flex
        align-items center
        justify-content center
        img
          height 38px
        .button
          width 100px
          height 36px
          border 1px solid #FF8824
          text-align center
          font-size 14px
          font-weight 500
          color #FF8824
          line-height 36px
          margin-top 20px
          cursor pointer
      .right
        font-size 12px
        font-weight 500
        color #666666
        line-height 20px
        width 572px
        padding 14px 0
        border-top 1px solid #eee
        border-bottom 1px solid #eee
        display flex
        flex-direction column
        justify-content space-between
        .line-1
          font-weight 500
          font-size 13px
          .orange
            cursor pointer
            color #ff8824
            &:hover
              color #FF6600
        .line-2
          font-size 12px
        .line-3
          font-weight 500
          font-size 13px
          .blue
            color #6888F8
            cursor pointer
            &:hover
              color #98aefb
    .rc-content
      margin-top 30px
      .title
        font-size 18px
        font-weight 500
        color #333333
        line-height 24px
      .a-list
        margin-top 15px
        padding-top 20px
        border-top 1px solid #eee
        display flex
        .item+.item
          margin-left 10px
        .item
          width 198px
          cursor pointer
          .img
            width 100%
            height 120px
            overflow hidden
            img
              width 100%
              height 100%
              &:hover
                transform scale(1.1)
                transition all 0.6s ease 0s
          p
            margin-top 10px
            font-size 14px
            font-weight 500
            color #333333
            line-height 20px
            &:hover
              color #FF8824
              transition all 0.5s
  &_rt
    flex 0 0 346px
    margin-left 34px
    .author
      .author-header
        display flex
        align-items center
        .logo
          width 90px
          height 90px
          border-radius 50%
        .right
          margin-left 13px
          line-height 1
          .name
            font-size 20px
            font-weight 500
            color #333333
            img
              margin-left 5px
          .desc
            font-size 14px
            font-weight 500
            color #999999
            margin-top 9px
      .lately
        margin-top 20px
        .se-title
          font-size 14px
          font-weight 500
          color #333333
          line-height 1
          padding-left 7px
          border-left 2px solid #FFBA80
        ul
          li
            margin-top 20px
            div
              font-size 14px
              font-weight 500
              color #333333
              line-height 20px
              cursor pointer
              &:hover
                color #ff8824
                transition all 0.5s
            p
              margin-top 10px
              font-size 12px
              font-weight 500
              color #999999
              line-height 1
        .flash-more
          margin-top 20px
    .org
      &-item
        background #F8F9FA
        padding 12px
        margin-top 12px
        display flex
        align-items center
        flex-flow wrap
        .logo
          width 60px
          height 60px
          display flex
          justify-content center
          align-items center
          background #fff
          border 1px solid #F5F5F5
          img
            max-width 100%
            max-height 100%
        .content
          line-height 1
          margin-left 10px
          width 180px
          div
            font-size 14px
            font-weight 500
            color #666666
            cursor pointer
            &:hover
              transition all 0.5s
              color #FF8824
          p
            margin-top 15px
            font-size 13px
            font-weight 500
            color #999
            line-height 1
        .follow1, .follow2
          width 56px
          height 28px
          text-align center
          line-height 28px
          font-size 12px
          font-weight 500
          border-radius 6px
          cursor pointer
          margin-left 12px
        .follow1
          background #F8F9FA
          border 1px solid #FF8824
          color #FF8824
          &:hover
            border-color #f60
            color #f60
        .follow2
          background #F0F0F0
          color #999
          &:hover
            background #eee
      .mode-title
        margin-bottom 20px
    .relation
      .title
        font-size 16px
        font-weight 500
        color #333333
        line-height 26px
        margin-top 19px
        cursor pointer
        &:hover
          color #FF8824
          transition all 0.5s
      .time
        font-size 12px
        font-weight 500
        color #999999
        margin-top 19px
.share-mode
  .ivu-modal-wrap
    display flex
    align-items center
    justify-content center
    .ivu-modal
      top 0
      .ivu-modal-body
        .share
          font-size 16px
          padding 40px 0 0
          font-weight 800
          text-align center
        .share_img
          text-align center
          margin 30px auto 10px
          display block
        .share_desc
          text-align center
          padding 20px 0 20px
          font-size 16px
</style>